import { useAuthStore } from '@shared/stores/authStore';

/**
 * Hook que expone las funciones de permisos del authStore de manera reactiva
 *
 * @example
 * ```tsx
 * const { canAccess, hasPermission } = usePermissions();
 * const canCreate = canAccess(['tenant'], ['products.create']);
 * ```
 */
export function usePermissions() {
  const store = useAuthStore();

  return {
    // 🎯 Obtener el tipo de team del usuario
    getTeamType: store.getTeamType,

    // 🎯 Obtener todos los permisos del usuario
    getUserPermissions: store.getUserPermissions,

    // 🎯 Verificar un permiso específico
    hasPermission: store.hasPermission,

    // 🎯 Verificar si tiene al menos uno de los permisos
    hasAnyPermission: store.hasAnyPermission,

    // 🎯 Verificar si tiene todos los permisos
    hasAllPermissions: store.hasAllPermissions,

    // 🎯 Verificación combinada: team_type + permisos
    canAccess: store.canAccess,

    // 🎯 Verificar si el usuario tiene rol de admin
    isAdminRole: store.isAdminRole,

    // 🎯 Verificar si wallet_visible está habilitado (para tenant_external)
    isWalletVisible: store.isWalletVisible,

    // 🎯 Proveedor contable del tenant (holded | contalink)
    getAccountingSupplier: store.getAccountingSupplier,
    isHoldedAccounting: store.isHoldedAccounting,
    isContalinkAccounting: store.isContalinkAccounting,
    isBlockModel: store.authorization?.model_version === 2 || store.role?.model_version === 2,
    authorizationScope: store.getAuthorizationScope(),

    // 🎯 Datos de contexto (útil para debugging)
    teamType: store.team?.type ?? null,
    permissions: store.role?.permissions ?? [],
  };
}
